import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon, LoaderIcon } from 'lucide-react';
import { useFormContext } from 'react-hook-form';
interface FormNavigationProps {
  onNext: () => void;
  onBack: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
  isSubmitting?: boolean;
}
const FormNavigation: React.FC<FormNavigationProps> = ({
  onNext,
  onBack,
  isFirstStep,
  isLastStep,
  isSubmitting = false
}) => {
  const {
    watch
  } = useFormContext();
  const formData = watch();
  // Check if confirmation checkbox is checked (only matters on last step)
  const isConfirmed = isLastStep ? formData.termsConfirm === 'true' : true;
  const isDisabled = isSubmitting || isLastStep && !isConfirmed;
  return <div className="flex justify-between items-center" data-id="element-39">
      <button onClick={onBack} disabled={isFirstStep || isSubmitting} className={`flex items-center px-4 py-2 rounded-md text-sm font-medium transition-colors ${isFirstStep || isSubmitting ? 'opacity-50 cursor-not-allowed text-slate-500 bg-slate-100' : 'text-navy-700 bg-slate-100 hover:bg-slate-200'}`} data-id="element-40">
        <ArrowLeftIcon size={16} className="mr-2" data-id="element-41" />
        Back
      </button>
      <button onClick={onNext} disabled={isDisabled} className={`flex items-center px-6 py-2 rounded-md text-sm font-medium transition-colors ${isDisabled ? 'opacity-50 cursor-not-allowed bg-slate-400 text-white' : 'bg-navy-700 text-white hover:bg-navy-800'}`} data-id="element-42">
        {isSubmitting ? <>
            Submitting...
            <LoaderIcon size={16} className="ml-2 animate-spin" data-id="element-43" />
          </> : isLastStep ? <>
            Submit Intake Form
            <CheckIcon size={16} className="ml-2" data-id="element-44" />
          </> : <>
            Next
            <ArrowRightIcon size={16} className="ml-2" data-id="element-45" />
          </>}
      </button>
    </div>;
};
export default FormNavigation;